import React from "react";
import "../styles/historique.css";
import { fetchDataFile } from "../components/Fetch";
import ReactHtmlParser from "react-html-parser";
import LeftColumn from "./columns/LeftColumn";
import RightColumn from "./columns/RightColumn";
import Footer from "./elements/Footer";

import {translate} from "../containers/i18n";
import {I18nContext} from './i18n';

class Historique extends React.Component {

  static contextType = I18nContext;

  constructor(props) {
    super(props);

    this.onLoadComplete = this.onLoadComplete.bind(this);
    this.updateHistoriqueContent = this.updateHistoriqueContent.bind(this);

    this.state = { htmlContent: null };
  }

  onLoadComplete(data) {
    const page = ReactHtmlParser(data);
    this.setState({ htmlContent: page });
  }

  updateHistoriqueContent(content) {
    const d = document.getElementById("mainContainer");

    if (d) {
      const h = content ? d.clientHeight + 512 : 1000;
      return h;
    } else {
      setTimeout(this.updateHistoriqueContent, 250);
    }
  }

  render() {
    const content = this.state.htmlContent;
    if (content) {
      const h = this.updateHistoriqueContent(content);
      const n = parseInt(h / 768);
  
      return (
        <>
          <div id="mainContainer" className="mainContainer">
            <LeftColumn pos="left" page="historique" n={n}/>
            <RightColumn pos="right" page="historique" n={n}/>
            <div id="cp" className="page historique" ref={this._element}>
              {content}
            </div>
          </div>
          <Footer />
        </>
      );
    }
    else {
      if (this.context) {
        const url = this.context.lang + "/historique";
        fetchDataFile(url, "", this.onLoadComplete);
      }
      return <div></div>
    }
  }
}

export default translate(Historique);
